<template>
  <div class="page newPerson">
    <!-- <navigation>新手指南</navigation> -->
    <div class="newPerson-detail">
      <img src="./images/img_1@2x.png">
      <img src="./images/img_2@2x.png">
      <img src="./images/img_3@2x.png">
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  mounted () {
    this.$bus.$emit('ready')
  }

}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.newPerson {
  background: #F7F7F7;
  
  .newPerson-detail{
    img {
      width: 100%;
    }
  }
  
}</style>